import { render, staticRenderFns } from "./CommonCenterList.vue?vue&type=template&id=4bc76883"
import script from "./CommonCenterList.vue?vue&type=script&lang=js"
export * from "./CommonCenterList.vue?vue&type=script&lang=js"
import style0 from "./CommonCenterList.vue?vue&type=style&index=0&id=4bc76883&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports